import { ICardProperty } from "@rf-model/card-property.model";
import { memo } from "react";
import usePropertyActionsPermissions from "../hooks/usePropertyActionsPermissions";
import usePropertyListLoading from "../hooks/usePropertyListLoading";
import { Grid } from "@mui/material";
import MxCardPropertyLarge from "@rf-l1/cards/property/MxCardPropertyLarge";
import PropertyCheckRefererOption from "./PropertyCheckRefererOption";
import MxListLoadingTemplate from "@rf-l1/page/list/MxlistLoadingTemplate";
import MxListErrorTemplate from "@rf-l1/page/list/MxlistErrorTemplate";
import MxListEmptyTemplate from "@rf-l1/page/list/MxlistEmptyTemplate";
import { PropertyListButtonFilters } from "./PropertyListButtonFilters";
import { getConditionStatusLabel } from "@/src-refactor/modules/shared/components/refactor/helpers/property/prepare-condition-status-label";
import { C_CONDICTION_PROPERTY } from "@/src-refactor/modules/shared/model/const/property/condition-status.const";

interface PropertyListCardProps {
  properties: ICardProperty[];
}
const PropertyListCardLarge = memo((props: PropertyListCardProps) => {
  const { getOptions, handleShowDetail } = usePropertyActionsPermissions();
  const { isLoading, isUninitialized, isError } = usePropertyListLoading();

  if (isLoading || isUninitialized) {
    return <MxListLoadingTemplate />;
  }
  if (isError) {
    return <MxListErrorTemplate />;
  }

  if (props.properties.length == 0) {
    return (
      <Grid container px={2} py={5}>
        <MxListEmptyTemplate
          variant="with-filters"
          title="¡Sin resultados!"
          description="Actualmente tus filtros están limitando la búsqueda. Ajusta tus filtros para descubrir más propiedades."
          button={<PropertyListButtonFilters />}
        />
      </Grid>
    );
  }
  return (
    <Grid container rowSpacing={1} py={1} px={2}>
      {props.properties?.map((property, index) => {
        const menuItems = getOptions(property.dirtyState);
        const conditionLabel = getConditionStatusLabel(
          property.conditionStatus,
          property.businessType
        );
        const conditionColor =
          conditionLabel === C_CONDICTION_PROPERTY.NEW.name ? "#8CC63F" : "red";

        return (
          <Grid item xs={12} key={property.id ?? index} position="relative">
            <Grid
              alignItems="center"
              container
              item
              xs={5}
              position="absolute"
              zIndex={110}
              px={2}
              py={1}
              gap={1}
            >
              {Boolean(conditionLabel) && (
                <Grid
                  xs="auto"
                  item
                  sx={{
                    background: conditionColor,
                    fontSize: 11,
                    color: "#fff",
                    fontWeight: 400,
                    padding: "5px 10px",

                    borderRadius: 0.3
                  }}
                >
                  {conditionLabel}
                </Grid>
              )}
              {property.isCollection && (
                <Grid
                  xs="auto"
                  item
                  sx={{
                    background: "red",
                    fontSize: 11,
                    color: "#fff",
                    fontWeight: 400,
                    padding: "5px 10px",

                    borderRadius: 0.3
                  }}
                >
                  Collection
                </Grid>
              )}
              <Grid flex={1}></Grid>
              <Grid item xs="auto">
                <PropertyCheckRefererOption property={property} staticCheck={true} />
              </Grid>
            </Grid>
            <MxCardPropertyLarge
              itemsMenu={menuItems}
              {...property}
              onClick={() => {
                handleShowDetail(Number(property.id));
              }}
            />
          </Grid>
        );
      })}
    </Grid>
  );
});

export default PropertyListCardLarge;
